'use client';

import {
  Dialog,
  Transition,
  DialogPanel,
  DialogTitle,
  TransitionChild,
} from '@headlessui/react';
import { Fragment, useContext, useEffect, useState } from 'react';
import { GrClose } from 'react-icons/gr';
import Form from '../pop-up-input-form';
import { ReportContext } from '@/app/providers/reportProvider';
import { createLead } from '@/app/lib/actions';
import { Tab, TabGroup, TabList, TabPanels, TabPanel } from '@headlessui/react';
import { FaRegHandPointRight } from 'react-icons/fa';
import { useRouter } from '@/i18n/routing';
import ImageSection from './image-section';
import { useLocale, useTranslations } from 'next-intl';

// PriceCards on the Instant Access

export default function LeadMagnet() {
  let [isOpen, setIsOpen] = useState(false);
  const report = useContext(ReportContext);
  const [isSubmited, setIsSubmited] = useState(false);
  const router = useRouter();
  const [locationData, setLocationData] = useState({ country: 'IN' });
  const [tabShouldHidden, setTabShouldHidden] = useState(false);
  const t = useTranslations('lead_magnet');
  const locale = useLocale();

  const date = new Date(report.newsDate);

  const options = {
    month: 'short',
    year: 'numeric',
  };

  const pubDate = date.toLocaleDateString(undefined, options);

  //Updating the Tab Options Based on Country
  useEffect(() => {
    if (
      locationData.country === 'US' ||
      locationData.country === 'JP' ||
      locationData.country === 'KR' ||
      locationData.country === 'GB' ||
      locationData.country === 'DE' ||
      locationData.country === 'FR' ||
      locationData.country === 'NL' ||
      locationData.country === 'IT' ||
      locationData.country === 'ES' ||
      locationData.country === 'CH' ||
      locationData.country === 'CA' ||
      locale === 'ja' ||
      locale === 'ko'
    ) {
      setTabShouldHidden(true);
    }
  }, [locationData, locale]);

  //Pop-Up Timing
  useEffect(() => {
    setTimeout(() => setIsOpen(true), 1 * 90000);
  }, []);

  //Redirction after form submission
  useEffect(() => {
    if (isSubmited) {
      router.push('/thank-you');
    }
  }, [isSubmited, router]);

  useEffect(() => {
    //Get the Geolocation of the user
    async function getLocation() {
      const baseURL =
        process.env.NODE_ENV === 'production'
          ? 'https://www.coherentmi.com'
          : 'http://localhost:3000';
      const res = await fetch(`${baseURL}/api/getClientLocation`);
      const data = await res.json();
      if (res.status === 200) setLocationData(data.location);
    }
    getLocation();
  }, []);

  function closeModal() {
    setIsOpen(false);
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-20" onClose={() => false}>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </TransitionChild>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-3 text-center ">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel
                  transition={true}
                  className="w-full max-w-[50rem] max-h-[80%] transform overflow-hidden rounded-lg bg-white text-center align-middle shadow-xl transition-all"
                >
                  <div className="flex justify-between p-2 relative">
                    <div>
                      <DialogTitle as="h3" className="leading-6 text-gray-900">
                        <div className="text-start">
                          <p className="uppercase text-md sm:text-lg font-semibold">
                            {report.keyword} {t('analysis')} (
                            {report.studyperiod})
                          </p>

                          <div className="flex flex-row gap-1 sm:gap-3 font-13">
                            <span className="text-xs">
                              {t('report_code')} : {report.newsId}
                            </span>
                            {/* <span className="text-xs">
                              {t('published_on')} : {pubDate}
                            </span> */}
                            <span className="text-xs">{t('format')} : PDF</span>
                          </div>
                        </div>
                      </DialogTitle>
                    </div>
                    <button
                      onClick={closeModal}
                      className="absolute border border-black rounded-md p-1 items-center text-center bg-blue-300 cursor-pointer right-2"
                    >
                      <GrClose size={15} />
                    </button>
                  </div>
                  <div className="bg-slate-300 h-px mb-1"></div>
                  <TabGroup>
                    {tabShouldHidden ? (
                      ''
                    ) : (
                      <TabList
                        className={
                          'flex justify-between gap-1 lg:gap-2 rounded-xlp-1 px-2'
                        }
                      >
                        <Tab
                          className={({ selected }) =>
                            classNames(
                              'w-full sm:w-3/5 rounded-t-sm lg:py-2.5 font-medium text-sm leading-5 font-8 sm:font-16 shadow-lg outline-none relative cursor-pointer',
                              selected
                                ? 'bg-gradient-to-b from-[#717BAD] to-[#739DED] text-white lg:arrow-button-lm'
                                : 'bg-white text-slate-800  border-slate-300 border'
                            )
                          }
                        >
                          {t('req_sample')}
                        </Tab>
                        <Tab
                          className={({ selected }) =>
                            classNames(
                              'w-full sm:w-2/5 rounded-t-sm text-sm font-medium leading-5 font-8 lg:font-16 shadow-lg flex flex-row gap-0 lg:gap-3 justify-center outline-none items-center relative cursor-pointer',
                              selected
                                ? 'text-white bg-gradient-to-b from-[#717BAD] to-[#739DED]'
                                : 'bg-gradient-to-r from-orange-500 to-pink-500 text-white border-slate-300 border'
                            )
                          }
                        >
                          <FaRegHandPointRight className="ms-1 lg:ms-0 animate-bounce" />{' '}
                          <span className="animate-pulse">{t('get_acc')}</span>
                        </Tab>
                      </TabList>
                    )}
                    <TabPanels className='bg-[url("/leadMagent_Bg.webp")] bg-cover mt-2'>
                      {tabShouldHidden ? (
                        <TabPanel>
                          <div className="flex justify-center">
                            <div className="bg-white m-2 rounded-md w-6/5 lg:w-3/5 transition duration-700 ease-in-out">
                              <p className="my-2 font-semibold text-sm lg:text-[15px]">
                                {/* {dict.lead_magnet.heading.p1}{' '}
                              <span className="text-green-500 font-12">
                                {' '}
                                {dict.lead_magnet.heading.p2}
                              </span> */}
                                {t('heading.p3')}
                                {t('heading.p4')}
                              </p>
                              <Form
                                formAction={createLead}
                                formType={'LeadMagnet'}
                                className={'pb-2 h-2/5 text-sm mx-3'}
                                setIsSubmitted={setIsSubmited}
                              />
                            </div>
                          </div>
                        </TabPanel>
                      ) : (
                        <>
                          <TabPanel>
                            <div className="flex flex-col lg:flex-row">
                              <div className="bg-white m-2 rounded-md lg:w-3/5 transition duration-700 ease-in-out">
                                <p className="mt-2 font-semibold text-sm lg:text-[15px]">
                                  {/* {dict.lead_magnet.heading.p1}{' '}
                              <span className="text-green-500 font-12">
                                {' '}
                                {dict.lead_magnet.heading.p2}
                              </span> */}
                                  {t('heading.p3')}
                                  {t('heading.p4')}
                                </p>
                                <Form
                                  formAction={createLead}
                                  formType={'LeadMagnet'}
                                  className={'pb-2 h-2/5 text-sm mx-3'}
                                  setIsSubmitted={setIsSubmited}
                                />
                              </div>
                              <div className="border border-slate-700 border-dashed w-1/3 h-0 mx-auto my-2 lg:hidden"></div>
                              <div className="justify-center items-center content-center mb-2 lg:mb-0 lg:w-2/5">
                                <ImageSection />
                              </div>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            {/* <InstantAccess
                              dict={dict}
                              orderAmount={orderAmount}
                              setOrderAmount={setOrderAmount}
                            /> */}
                            <div className="flex justify-center">
                              <div className="bg-white m-2 rounded-md w-6/5 lg:w-3/5 transition duration-700 ease-in-out my-2">
                                <p className="mt-2 font-semibold text-sm lg:text-[15px]">
                                  {/* {dict.lead_magnet.heading.p1}{' '}
                              <span className="text-green-500 font-12">
                                {' '}
                                {dict.lead_magnet.heading.p2}
                              </span> */}
                                  {t('heading.p3')}
                                  {t('heading.p4')}
                                </p>
                                <Form
                                  formAction={createLead}
                                  formType={'GetQuote'}
                                  className={'pb-2 h-2/5 text-sm m-3'}
                                  isGetQuote={true}
                                  setIsSubmitted={setIsSubmited}
                                />
                              </div>
                            </div>
                          </TabPanel>
                        </>
                      )}
                    </TabPanels>
                  </TabGroup>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
